import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiUsers } from "../api/axiosClient";
import { logoutThunk } from "../redux/state/loginstate/user";
import { persistor } from "../redux/store";
import { STORAGE_SESSION_ACTIVE } from "../utils/storageKeys";
import { toast } from "../utils/toast";

const DeleteSessions = () => {
  /* --------------------------  --------------------------  */

  const [error, setError] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [status, setStatus] = useState("");
  const [mensaje, setMensaje] = useState("");

  /* --------------------------  --------------------------  */

  const navigate = useNavigate();

  /* --------------------------  --------------------------  */

  const dispatch = useDispatch();

  /* --------------------------  --------------------------  */

  const userdata = useSelector((state) => state.user);
  const { codigoAfiliado } = userdata;

  /* --------------------------  --------------------------  */

  const HandleDeleteSession = async () => {
    if (!codigoAfiliado) return;

    setIsFetching(true);

    try {
      // 🔹 1. Cierra sesión en Redux (reset de estado global)
      await dispatch(logoutThunk());

      // 🔹 2. Borra almacenamiento persistente de Redux
      await persistor.purge();

      // 🔹 3. Llama a tu backend para eliminar sesión activa
      const response = await apiUsers.delete("/eliminarLogin", {
        params: {
          codigoAfiliado: codigoAfiliado,
        },
      });

      if (response.status === 200) {
        const { mensaje } = response.data;
        setStatus(response.status);
        setMensaje(mensaje);

        // 🔹 4. Limpia todo el storage sensible
        sessionStorage.removeItem("expiretime");
        localStorage.removeItem(STORAGE_SESSION_ACTIVE);

        // 🔹 5. Muestra éxito y redirige
        toast.success("Sesión cerrada.");
        navigate("/", { replace: true });
      }
    } catch (error) {
      // 🔻 Manejo de errores de respuesta
      if (error.response) {
        const { mensaje } = error.response.data || {};
        setError(mensaje);
        setMensaje(mensaje);
        toast.warning(mensaje || "Ocurrió un error en el servidor.");
      } else {
        // 🔻 Error de red o inesperado
        toast.warning("Ocurrió algo inesperado.");
      }
    } finally {
      setIsFetching(false);
    }
  };

  /* --------------------------  --------------------------  */

  return { error, status, mensaje, isFetching, HandleDeleteSession };
};

export default DeleteSessions;
